import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

interface CourierServiceOption {
  id: string;
  name: string;
  courier_id: number;
}

export const useCourierServices = (courierId: string) => {
  const httpClient = createHttpClient(apiClientWH);

  return useQuery<CourierServiceOption[]>({
    queryKey: ['courier-services', courierId],
    queryFn: async () => {
      const raw = await httpClient.get<any>(
        `/couriers/${courierId}/services`,
        {},
        {},
        false
      );
      const list = Array.isArray(raw) ? raw : (raw.data ?? []);
      return list.map((s: any) => ({
        id: String(s.id),
        name: s.description || s.code,
        courier_id: s.courier_id,
      }));
    },
    enabled: !!courierId,
    staleTime: 5 * 60 * 1000,
  });
};
